var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSettingGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "More_Vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 18.3394C11 18.8916 11.4477 19.3394 12 19.3394C12.5523 19.3394 13 18.8916 13 18.3394C13 17.7871 12.5523 17.3394 12 17.3394C11.4477 17.3394 11 17.7871 11 18.3394Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.3394C11 12.8916 11.4477 13.3394 12 13.3394C12.5523 13.3394 13 12.8916 13 12.3394C13 11.7871 12.5523 11.3394 12 11.3394C11.4477 11.3394 11 11.7871 11 12.3394Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6.33936C11 6.89164 11.4477 7.33936 12 7.33936C12.5523 7.33936 13 6.89164 13 6.33936C13 5.78707 12.5523 5.33936 12 5.33936C11.4477 5.33936 11 5.78707 11 6.33936Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18.3394C11 18.8916 11.4477 19.3394 12 19.3394C12.5523 19.3394 13 18.8916 13 18.3394C13 17.7871 12.5523 17.3394 12 17.3394C11.4477 17.3394 11 17.7871 11 18.3394Z",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.3394C11 12.8916 11.4477 13.3394 12 13.3394C12.5523 13.3394 13 12.8916 13 12.3394C13 11.7871 12.5523 11.3394 12 11.3394C11.4477 11.3394 11 11.7871 11 12.3394Z",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6.33936C11 6.89164 11.4477 7.33936 12 7.33936C12.5523 7.33936 13 6.89164 13 6.33936C13 5.78707 12.5523 5.33936 12 5.33936C11.4477 5.33936 11 5.78707 11 6.33936Z",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSettingGray);
export default __webpack_public_path__ + "static/media/ic_setting_gray.caef067dccb7e13e63e860671ab3a894.svg";
export { ForwardRef as ReactComponent };